import React, { Component } from "react";
import Utils from "../../Utils";
import { Cargando } from '../estados/Cargando';
import { UncontrolledTooltip } from 'reactstrap';
import "./beneficios.css";

export class Beneficios extends Component {

    constructor(props) {
        super(props);
        this.state = {
            beneficios: {},
            niveles: [],
            estado: false
        };
    }

    componentDidMount() {
        this.getgetBeneficios();
        this.getgetNiveles();
    }

    async getgetBeneficios() {
        this.setState({ estado: false })
        await Utils.getBeneficios()
            .then(data => {
                if (data !== undefined) {
                    this.setState({ beneficios: data, estado: true })
                }
            });
    }

    async getgetNiveles() {
        await Utils.getNiveles()
            .then(data => {
                if (data !== undefined) {
                    this.setState({ niveles: data.reverse(),})
                }
            })
    }

    procesoValor(valor) {
        if (valor === undefined) return undefined;
        if (valor === "") return <>-</>;
        if (valor === "ok") return <img src="/check-ok.svg" alt="x" width="19px" />;
        if (valor === "x") return <img src="/check-x.svg" alt="x" width="19px" />;
        if (valor.slice(0, 1) === '(' && valor.slice(-1) === ')') {
            return <p>{valor.slice(1, -1)}</p>
        }
        return valor;

    }

    render() {
        return (
            <div className="row">
                {!this.state.estado ? <div><Cargando></Cargando></div> :
                <div className="col-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <td style={{ visibility: "hidden" }}></td>
                                <th scope="col">Nivel 5 </th>
                                <th scope="col">Nivel 4</th>
                                <th scope="col">Nivel 3</th>
                                <th scope="col">Nivel 2</th>
                                <th scope="col">Nivel 1</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.beneficios.map((beneficio) => (
                                <tr>
                                    <td className="detalle">
                                        <span>{beneficio.nombre}</span>
                                        <img src="/info547.svg" alt="info" className="icon-info" width="19px" id={"tooltip" + beneficio.id} />
                                        <UncontrolledTooltip placement="top" target={"tooltip" + beneficio.id} >
                                            {beneficio.informacion}
                                        </UncontrolledTooltip >
                                    </td>
                                    <td> {this.procesoValor(beneficio.valor5)} </td>
                                    <td> {this.procesoValor(beneficio.valor4)} </td>
                                    <td> {this.procesoValor(beneficio.valor3)} </td>
                                    <td> {this.procesoValor(beneficio.valor2)} </td>
                                    <td> {this.procesoValor(beneficio.valor1)} </td>
                                </tr>
                            ))}
                            <tr className="ultima-row">
                                <th scope="row" style={{ visibility: "hidden" }} >Intervalo de %</th>
                                {this.state.niveles.map((nivel) => (
                                    <td>
                                        <b>score</b>
                                        {nivel.maximo} a {nivel.minimo}%
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
                }
            </div>
        );
    }
}